import   axios  from 'axios';

import { getDetailledIpAddressInformationsWithIp } from '../networkManagment/api'

import { BackendResponse                             ,
         handleError                                 ,
         PROMOTION_CONFIRMATION_REQUIRED_CODE        ,
         USER_DELETION_CONFIRMATION_REQUIRED_CODE    ,
         ALREADY_PSEUDO_DELETED_CODE                 }  from '../../dataTypes/backendServicesManagment/types';

import { Admin            ,
         initializedAdmin }  from '../../dataTypes/adminManagment/types';

import { API_URLS         ,
         WWW_URLS         }  from '../urls';


import { getUserAgentInformations }  from '../../utils/utils_userAgent';
import { getAppInformations       }  from '../../utils/utils_app';


export interface BackendResponse_Admins extends BackendResponse<Admin[]> {}

export const getAdmins = async ( ): Promise<BackendResponse_Admins> => {

  const url = API_URLS.getAdmins;

  console.log ('getAdmins: ' ,url)

  try 
   {
    const response = await axios.get(url);
	
	console.log (url, response)

    if (response.status === 200) 
	      {
           const admins: Admin[] = response.data.map ((admin: any) => {

             const defaultAdmin = initializedAdmin();

             return {
                      ...defaultAdmin,
                      id              : admin.id              ?? defaultAdmin.id              ,
                      email           : admin.email           ?? defaultAdmin.email           ,
                      lastname        : admin.lastname        ?? defaultAdmin.lastname        ,
                      firstname       : admin.firstname       ?? defaultAdmin.firstname       ,
                      role            : admin.role            ?? defaultAdmin.role            ,
                      lastLoginDate   : admin.lastLoginDate   ? new Date ( admin.lastLoginDate ) : defaultAdmin.lastLoginDate ,
                      lastLoginIP     : admin.lastLoginIP     ?? defaultAdmin.lastLoginIP     ,
                      lastLoginCity   : admin.lastLoginCity   ?? defaultAdmin.lastLoginCity   ,
                      lastLoginDevice : admin.lastLoginDevice ?? defaultAdmin.lastLoginDevice ,
                      quotaDisk       : admin.quotaDisk       ?? defaultAdmin.quotaDisk       ,
                      quotaUsed       : admin.quotaUsed       ?? defaultAdmin.quotaUsed       ,
                      nbDevicesMax    : admin.nbDevicesMax    ?? defaultAdmin.nbDevicesMax    ,
                      nbDevicesUsed   : admin.nbDevicesUsed   ?? defaultAdmin.nbDevicesUsed   ,
                      nbChannelsMax   : admin.nbChannelsMax   ?? defaultAdmin.nbChannelsMax   ,
                      nbChannelsUsed  : admin.nbChannelsUsed  ?? defaultAdmin.nbChannelsUsed  ,
                      uuid            : admin.uuid            ?? defaultAdmin.uuid            ,
                      publicRef       : admin.publicRef            ?? defaultAdmin.publicRef            ,
                      photoFile       : admin.photoFile       ?? defaultAdmin.photoFile       ,
                      bannerFile      : admin.bannerFile      ?? defaultAdmin.bannerFile      ,
                      profileRole     : admin.profileRole     ?? defaultAdmin.profileRole     ,
                      pseudonym       : admin.pseudonym       ?? defaultAdmin.pseudonym       ,
                      slug            : admin.slug            ?? defaultAdmin.slug            ,
                      biography       : admin.biography       ?? defaultAdmin.biography       ,
                      personalPageUrl : admin.personalPageUrl ?? defaultAdmin.personalPageUrl ,
                      reporterAvailable : admin.reporterAvailable ?? defaultAdmin.reporterAvailable ,
                      reporterCity      : admin.reporterCity      ?? defaultAdmin.reporterCity      ,
                      reporterRadiusKm  : admin.reporterRadiusKm  ?? defaultAdmin.reporterRadiusKm  ,
                      verified        : admin.verified        ?? defaultAdmin.verified        ,
                      accountStatus   : admin.accountStatus   ?? defaultAdmin.accountStatus   ,
                      useFiligrane    : admin.useFiligrane    ?? defaultAdmin.useFiligrane    ,
                      durationMaxBroadcasting     : admin.durationMaxBroadcasting     ?? defaultAdmin.durationMaxBroadcasting     ,
                      durationElapsedBroadcasting : admin.durationElapsedBroadcasting ?? defaultAdmin.durationElapsedBroadcasting ,
                      broadcastSeconds            : admin.broadcastSeconds            ?? defaultAdmin.broadcastSeconds            ,
                      broadcastSessions           : admin.broadcastSessions           ?? defaultAdmin.broadcastSessions           ,
                      durationMaxRecording        : admin.durationMaxRecording        ?? defaultAdmin.durationMaxRecording        ,
                      durationElapsedRecording    : admin.durationElapsedRecording    ?? defaultAdmin.durationElapsedRecording    ,
                      nbSubscribers   : admin.nbSubscribers   ?? defaultAdmin.nbSubscribers   ,
                      address         : admin.address         ?? defaultAdmin.address         ,
                      zipCode         : admin.zipCode         ?? defaultAdmin.zipCode         ,
                      city            : admin.city            ?? defaultAdmin.city            ,
                      region          : admin.region          ?? defaultAdmin.region          ,
                      country         : admin.country         ?? defaultAdmin.country         ,
                      creationDate         : admin.creationDate         ? new Date ( admin.creationDate )         : null,
                      lastModificationDate : admin.lastModificationDate ? new Date ( admin.lastModificationDate ) : null,
					};
           });

           return {
                    code    : 1,
                    comment : 'The retrieval of admins is complete.',
                    payload : admins,
                  };
          } 
	 else {
           return handleError<Admin[]>(response.status, 'Non-200 response from API');
          }
   } 
  catch (error) 
   {
    console.log(url, error);

    if (axios.isAxiosError(error)) 
	 {
      return handleError<Admin[]>(-101, error.response?.data?.detail ?? error.message);
     }
    return handleError<Admin[]>(-102, 'Unknown error');
  }
};

export interface BackendResponse_CheckSlugExistence extends BackendResponse<boolean> {}

// excludeId : ignore le compte en cours d'édition (son propre slug inchangé n'est pas un conflit)
export const checkSlugExistenceAdmin = async ( slug: string , excludeId?: number ) : Promise<BackendResponse_CheckSlugExistence> => {

  const url = `${API_URLS.checkSlugExistenceAdmin}?slug=${encodeURIComponent(slug)}${excludeId !== undefined ? `&excludeId=${excludeId}` : ''}`;

  try
   {
    const response = await axios.get ( url );

    if ( response.status === 200 )
          {
           if ( response.data.exist !== -1 )
                 {
                  return {
                           code    : 1,
                           comment : response.data.comment,
                           payload : response.data.exist === 1,
                         };
                 }
            else {
                  return handleError<boolean> ( -103 , `Erreur : ${response.data.comment}` );
                 }
          }
     else {
           return handleError<boolean> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<boolean> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<boolean> ( -102 , 'Unknown error' );
   }
};

export interface AdminProfilePayload
 {
  email?           : string ,
  password?        : string ,
  pseudonym?       : string ,
  slug?            : string ,
  biography?       : string ,
  personalPageUrl? : string ,
  reporterAvailable? : boolean,
  reporterCity?      : string,
  reporterRadiusKm?  : number | null,
  profileRole?     : string ,
  verified?        : boolean,
  accountStatus?   : string ,
  useFiligrane?    : boolean,
  durationMaxBroadcasting?     : number,
  durationElapsedBroadcasting? : number,
  durationMaxRecording?        : number,
  durationElapsedRecording?    : number,
  address?         : string ,
  zipCode?         : string ,
  city?            : string ,
  region?          : string ,
  country?         : string ,
  quotaDisk?       : number ,
  nbDevicesMax?    : number ,
  nbChannelsMax?   : number ,
 }

export const createAdmin = async ( email:        string ,
                                   password:     string ,
                                   firstname:    string ,
                                   lastname:     string ,
                                   profile?:     AdminProfilePayload ,
                                   isPromotion?: boolean ,
                                   adminId?:     number ) : Promise<BackendResponse<number>> => {

  const url = API_URLS.createAdmin;

  // X-Admin-Id identifie le superadmin qui crée/promeut ce compte — sert à tracer
  // l'action dans AdminActionLog (best-effort côté serveur si absent, cf. AdminCreation).
  const headers = { 'X-Admin-Id' : adminId ?? '' };

  try
   {
    const response = await axios.post ( url , { email , password , firstname , lastname , isPromotion: isPromotion === true , ...(profile ?? {}) } , { headers } );

    if ( response.status === 200 || response.status === 201 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : response.data?.id ?? 0,
                  }
          }
     else {
           return handleError<number> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      // Un compte client existe déjà avec cet e-mail : AdminCreation refuse (409) tant
      // que la promotion n'a pas été confirmée — ce n'est pas une panne, l'écran doit
      // pouvoir poser la question plutôt qu'afficher une erreur générique.
      if ( error.response?.status === 409 && error.response?.data?.requiresPromotionConfirmation === true )
       {
        return handleError<number> (
                                     PROMOTION_CONFIRMATION_REQUIRED_CODE ,
                                     error.response?.data?.message ?? 'Confirmation de promotion requise' ,
                                     error.response?.data?.existingUser?.id ?? 0
                                    );
       }

      return handleError<number> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<number> ( -102 , 'Unknown error' );
   }
};

export interface BackendResponse_AuthenticationToken extends BackendResponse<string> {}

export const postAdminAuthentication = async ( email:    string ,
                                               password: string ) : Promise<BackendResponse_AuthenticationToken> => {

  try
   {
    const response = await axios.post ( `${API_URLS.postAdminAuthentication}` , { email , password } );


    if ( response.status === 200 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : response.data.token
                  }
          }
     else {
           return {
                    code    : -1,
                    comment : 'Echec',
                    payload : ''
                  }
          }
    }
   catch (err)
    {
     // Un refus d'authentification arrive ici : axios traite le 401 comme une exception.
     // Le corps porte le motif ({"code":401,"message":"…"}), et l'API l'utilise pour dire
     // qu'un compte n'est pas actif — le confondre avec une panne réseau enverrait la
     // personne vérifier sa connexion au lieu de lui dire l'état de son compte.
     if ( axios.isAxiosError(err) && err.response )
      {
       const serverMessage = typeof err.response.data?.message === 'string' ? err.response.data.message : '';

       // « Invalid credentials. » est le message par défaut de LexikJWT pour un mot de passe
       // faux : en anglais, et sans intérêt puisque l'écran a déjà sa propre formulation.
       // Seul un motif rédigé par l'application mérite d'être affiché tel quel.
       const isGenericCredentialsMessage = /credentials/i.test(serverMessage);

       return {
                code    : -1,
                comment : isGenericCredentialsMessage ? '' : serverMessage,
                payload : ""
              };
      }

     // Ce commentaire est affiché tel quel sur l'écran de connexion : il doit
     // s'adresser à la personne, pas au développeur.
     return {
		      code    : -201,
		      comment : "Le serveur est injoignable. Vérifiez votre connexion, puis réessayez.",
              payload : ""
		    };

    }
}

// Trace chaque tentative de connexion créateur dans UserActionLog (succès, échec, ou
// erreur réseau) — même mécanisme que customer-front pour le login client. Sans cet
// appel, AuthenticationResult (admin-api) n'est jamais atteint et rien n'est tracé, quel
// que soit le résultat de postAdminAuthentication.
export const postAuthenticationResult = async ( email:  string ,
                                                 result: string ,
                                                 comment?: string ): Promise<BackendResponse<null>> => {

  const url = API_URLS.postAuthenticationResult;

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept'                   : 'application/ld+json',
    'Content-Type'             : 'application/ld+json',
    'User-Agent-Informations'  : `${userAgentInformations}`,
    'App-Informations'         : `${appInformations}`,
  };

  try
   {
    const response = await axios.post ( url , { email , result , comment } , { headers } );

    if ( response.status === 200 || response.status === 201 )
          {
           return { code: 1 , comment: 'ok' , payload: null };
          }
     else {
           return handleError<null> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    // Best effort : un échec de traçage ne doit jamais faire échouer l'écran de connexion.
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<null> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<null> ( -102 , 'Unknown error' );
   }
};


// Le message du serveur (AdminAccountChecker) pour une adresse e-mail non validée : l'écran de
// connexion s'en sert pour proposer le renvoi du mail. Doit rester une portion de ce message.
export const EMAIL_NOT_VALIDATED_MARKER = "pas encore été validée";

// Renvoie le mail de validation de l'adresse. L'e-mail ET le mot de passe sont exigés par le
// serveur : seul le titulaire du compte peut le demander. Le commentaire renvoyé est affiché
// tel quel à la personne.
export const postEmailValidationResend = async ( email:    string ,
                                                   password: string ): Promise<BackendResponse<null>> => {

  try
   {
    const response = await axios.post ( API_URLS.postEmailValidationResend , { email , password } );

    // code 1 : mail envoyé ; 2 : adresse déjà validée (la personne peut se reconnecter).
    return response.data?.code === 2
           ? { code: 2 , comment: "Votre adresse est déjà validée : vous pouvez vous connecter." , payload: null }
           : { code: 1 , comment: "Un mail de validation vient de vous être envoyé. Cliquez sur le lien qu'il contient, puis reconnectez-vous." , payload: null };
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) && error.response )
     {
      const status = error.response.status;

      if ( status === 429 ) return { code: -2 , comment: error.response.data?.comment ?? "Trop de demandes. Réessayez dans quelques minutes." , payload: null };
      if ( status === 401 ) return { code: -1 , comment: "Mot de passe incorrect : le mail n'a pas été renvoyé." , payload: null };

      return { code: -3 , comment: error.response.data?.comment ?? "Le mail n'a pas pu être envoyé. Réessayez plus tard." , payload: null };
     }

    return { code: -201 , comment: "Le serveur est injoignable. Vérifiez votre connexion, puis réessayez." , payload: null };
   }
};


// Demande de réinitialisation du mot de passe : le serveur envoie un mail dont le lien mène à la
// page de réinitialisation du portail. Comme sur le portail, toute réponse du serveur vaut
// « demande traitée » (on ne révèle pas si l'adresse existe) ; seule une panne réseau échoue.
export const getPasswordResetRequest = async ( email: string ): Promise<boolean> => {

  try
   {
    await axios.get ( API_URLS.getPasswordResetRequest , { params: { email } } );
    return true;
   }
  catch ( error )
   {
    return axios.isAxiosError ( error ) && error.response !== undefined;
   }
};


export interface BackendResponse_Admin extends BackendResponse<Admin> {}

export const getAdminInfosByEmail = async ( email: string ) : Promise<BackendResponse_Admin> => {

  const url     = API_URLS.getAdminInfosByEmail;
  const params  = `?email=${email}`
  const fullUrl = `${url}${params}`

  try
   {
    const response = await axios.get ( fullUrl );

    if ( response.status === 200 )
          {
           const initialAdmin = initializedAdmin()

           const response2 = await getDetailledIpAddressInformationsWithIp ( response.data.lastLoginIP  );

           let city:string = ""

           if ( response2.code === 1 )
            {
             city = response2.payload.ipApiCom_city
            }


           const admin: Admin = {
             id              : response.data.id              ?? initialAdmin.id,
             email           : response.data.email           ?? initialAdmin.email,
             lastname        : response.data.lastname        ?? initialAdmin.lastname,
             firstname       : response.data.firstname       ?? initialAdmin.firstname,
             role            : response.data.role            ?? initialAdmin.role,
             lastLoginDate   : response.data.lastLoginDate   ?   new Date ( response.data.lastLoginDate ) : null,
             lastLoginIP     : response.data.lastLoginIP     ?? initialAdmin.lastLoginIP,
             lastLoginCity   : city                          ?? initialAdmin.lastLoginCity,
             lastLoginDevice : response.data.lastLoginDevice ?? initialAdmin.lastLoginDevice,
             quotaDisk       : response.data.quotaDisk       ?? initialAdmin.quotaDisk,
             quotaUsed       : response.data.quotaUsed       ?? initialAdmin.quotaUsed,
             nbDevicesMax    : response.data.nbDevicesMax    ?? initialAdmin.nbDevicesMax,
             nbDevicesUsed   : response.data.nbDevicesUsed   ?? initialAdmin.nbDevicesUsed,
             nbChannelsMax   : response.data.nbChannelsMax   ?? initialAdmin.nbChannelsMax,
             nbChannelsUsed  : response.data.nbChannelsUsed  ?? initialAdmin.nbChannelsUsed,
             uuid            : response.data.uuid            ?? initialAdmin.uuid,
             publicRef       : response.data.publicRef            ?? initialAdmin.publicRef,
             photoFile       : response.data.photoFile       ?? initialAdmin.photoFile,
             bannerFile      : response.data.bannerFile      ?? initialAdmin.bannerFile,
             profileRole     : response.data.profileRole     ?? initialAdmin.profileRole,
             pseudonym       : response.data.pseudonym       ?? initialAdmin.pseudonym,
             slug            : response.data.slug            ?? initialAdmin.slug,
             biography       : response.data.biography       ?? initialAdmin.biography,
             personalPageUrl : response.data.personalPageUrl ?? initialAdmin.personalPageUrl,
             reporterAvailable : response.data.reporterAvailable ?? initialAdmin.reporterAvailable,
             reporterCity      : response.data.reporterCity      ?? initialAdmin.reporterCity,
             reporterRadiusKm  : response.data.reporterRadiusKm  ?? initialAdmin.reporterRadiusKm,
             verified        : response.data.verified        ?? initialAdmin.verified,
             accountStatus   : response.data.accountStatus   ?? initialAdmin.accountStatus,
             useFiligrane    : response.data.useFiligrane    ?? initialAdmin.useFiligrane,
             durationMaxBroadcasting     : response.data.durationMaxBroadcasting     ?? initialAdmin.durationMaxBroadcasting,
             durationElapsedBroadcasting : response.data.durationElapsedBroadcasting ?? initialAdmin.durationElapsedBroadcasting,
             broadcastSeconds            : response.data.broadcastSeconds            ?? initialAdmin.broadcastSeconds,
             broadcastSessions           : response.data.broadcastSessions           ?? initialAdmin.broadcastSessions,
             durationMaxRecording        : response.data.durationMaxRecording        ?? initialAdmin.durationMaxRecording,
             durationElapsedRecording    : response.data.durationElapsedRecording    ?? initialAdmin.durationElapsedRecording,
             // Pas encore renvoyés par admin-api (colonnes à ajouter côté kleon-core-api) —
             // retombent sur les valeurs par défaut tant que le backend ne les porte pas.
             durationMaxBroadcastingResetFrequency : response.data.durationMaxBroadcastingResetFrequency ?? initialAdmin.durationMaxBroadcastingResetFrequency,
             durationMaxBroadcastingResetDay       : response.data.durationMaxBroadcastingResetDay       ?? initialAdmin.durationMaxBroadcastingResetDay,
             durationMaxBroadcastingResetTime      : response.data.durationMaxBroadcastingResetTime      ?? initialAdmin.durationMaxBroadcastingResetTime,
             durationMaxRecordingResetFrequency    : response.data.durationMaxRecordingResetFrequency    ?? initialAdmin.durationMaxRecordingResetFrequency,
             durationMaxRecordingResetDay          : response.data.durationMaxRecordingResetDay          ?? initialAdmin.durationMaxRecordingResetDay,
             durationMaxRecordingResetTime         : response.data.durationMaxRecordingResetTime         ?? initialAdmin.durationMaxRecordingResetTime,
             nbSubscribers   : response.data.nbSubscribers   ?? initialAdmin.nbSubscribers,
             address         : response.data.address         ?? initialAdmin.address,
             zipCode         : response.data.zipCode         ?? initialAdmin.zipCode,
             city            : response.data.city            ?? initialAdmin.city,
             region          : response.data.region          ?? initialAdmin.region,
             country         : response.data.country         ?? initialAdmin.country,
             creationDate         : response.data.creationDate         ? new Date ( response.data.creationDate )         : null,
             lastModificationDate : response.data.lastModificationDate ? new Date ( response.data.lastModificationDate ) : null,
           };



           return {
                    code    : 1,
                    comment : 'ok',
                    payload : admin
                  }
          }
     else {
           return {
                    code    : -1,
                    comment : 'Echec',
                    payload : initializedAdmin()
                  }
          }
    }
   catch (err)
    {

     return {
		      code    : -201,
		      comment : "Erreur réseau",
              payload : initializedAdmin()
		    };

    }
}


// Le nom du fichier public (profil.webp / banner.webp) ne change jamais d'un upload
// à l'autre : sans ceci l'image affichée resterait celle mise en cache par le
// navigateur après une mise à jour. AdminPhotoUpdate/AdminBannerUpdate touchent
// lastModificationDate à chaque changement, ce qui fait varier l'URL.
const cacheBustingSuffix = ( admin: Admin ): string =>
  admin.lastModificationDate ? `?v=${admin.lastModificationDate.getTime()}` : '';

export const getAdminPhotoUrl = ( admin: Admin ): string => {

  if ( !admin.photoFile || admin.photoFile === '' ) return '';

  // Même mécanique qu'un media de type Video : image publique servie par le
  // serveur média sous files/public/{publicRef}/images/profil.webp
  if ( admin.publicRef && admin.publicRef !== '' )
   {
    return `${WWW_URLS.MediaServer}${admin.publicRef}/images/profil.webp${cacheBustingSuffix(admin)}`;
   }

  // Fallback admins legacy (photo uploadée avant la colonne uuid) : endpoint authentifié
  return API_URLS.getAdminPhotoFile.replace ( '{id}' , `${admin.id}` );
};

export const updateAdminPhoto = async ( id                     : number       ,
                                        photoFileToUpload      : File | null  ,
                                        photoMarkedForDeleting : boolean      ) : Promise<BackendResponse<string>> => {

  const url = API_URLS.updateAdminPhoto.replace ( '{id}' , `${id}` );

  const formData = new FormData();

  if ( photoFileToUpload      !== null ) { formData.append ( 'photoFileToUpload'      , photoFileToUpload ); }
  if ( photoMarkedForDeleting          ) { formData.append ( 'photoMarkedForDeleting' , 'true'            ); }

  try
   {
    const response = await axios.post ( url , formData );

    if ( response.status === 200 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : response.data?.photoFile ?? '',
                  }
          }
     else {
           return handleError<string> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<string> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<string> ( -102 , 'Unknown error' );
   }
};


export interface BackendResponse_NbDevicesUsed extends BackendResponse<number> {}

const postAdminDeviceCountChange = async ( url : string , id : number , deviceId?: string , label?: string , authMode?: string , transport?: string , channelName?: string ) : Promise<BackendResponse_NbDevicesUsed> => {

  const fullUrl = url.replace ( '{id}' , `${id}` );

  try
   {
    // deviceId/label/authMode/transport optionnels : seuls transmis pour une vraie
    // création/suppression de caméra (pour le log), jamais pour la réservation de slot
    // suivie d'un rollback silencieux — cf. AdminDeviceIncrement/Decrement.php.
    const response = await axios.post ( fullUrl , ( deviceId !== undefined || label !== undefined ) ? { deviceId, label, authMode, transport, channelName } : undefined );

    if ( response.status === 200 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : response.data?.nbDevicesUsed ?? 0,
                  }
          }
     else {
           return handleError<number> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      if ( error.response?.status === 409 )
       {
        return handleError<number> ( 409 , "Quota d'appareils atteint" );
       }
      return handleError<number> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<number> ( -102 , 'Unknown error' );
   }
};

export const incrementAdminDevicesUsed = ( id: number , deviceId?: string , label?: string , authMode?: string , transport?: string , channelName?: string ) : Promise<BackendResponse_NbDevicesUsed> =>
  postAdminDeviceCountChange ( API_URLS.incrementAdminDevicesUsed , id , deviceId , label , authMode , transport , channelName );

export const decrementAdminDevicesUsed = ( id: number , deviceId?: string , label?: string , authMode?: string ) : Promise<BackendResponse_NbDevicesUsed> =>
  postAdminDeviceCountChange ( API_URLS.decrementAdminDevicesUsed , id , deviceId , label , authMode );


export interface BackendResponse_AdminActionLog extends BackendResponse<void> {}

// Point d'entrée générique de l'onglet Logs d'un créateur : jamais d'exception
// remontée à l'appelant (même contrat que postAdminEvent), pour qu'un log
// perdu ne puisse jamais faire échouer l'action réelle (connexion device,
// ajout d'une source, etc.) qu'il se contente de raconter après coup.
export const createAdminActionLog = async ( id      : number ,
                                            module  : string ,
                                            action  : string ,
                                            result  : string ,
                                            comment : string = '' ) : Promise<BackendResponse_AdminActionLog> => {

  const fullUrl = API_URLS.createAdminActionLog.replace ( '{id}' , `${id}` );

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  try
   {
    const response = await axios.post ( fullUrl , { module , action , result , comment } , {
                                          headers: {
                                            'User-Agent-Informations' : `${userAgentInformations}`,
                                            'App-Informations'        : `${appInformations}`,
                                          }
                                        } );

    if ( response.status === 201 )
          {
           return { code: 1 , comment: 'ok' , payload: undefined };
          }
     else {
           return handleError<void> ( response.status , 'Non-201 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<void> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<void> ( -102 , 'Unknown error' );
   }
};


export interface AdminUsageCounters {
  nbDevicesUsed               : number;
  durationElapsedBroadcasting : number;
  durationElapsedRecording    : number;
  // Uniquement renseigné quand nbDevicesUsed fait partie du reset : nombre de devices
  // distants réellement déconnectés sur les canaux du créateur (cf. AdminUsageReset.php).
  disconnectedDevices?        : number | null;
}

// Les trois compteurs réinitialisables — PAS `keyof AdminUsageCounters`, qui inclurait
// aussi `disconnectedDevices` (une métadonnée de réponse, pas un compteur à réinitialiser).
export type AdminUsageCounterField = 'nbDevicesUsed' | 'durationElapsedBroadcasting' | 'durationElapsedRecording';

export interface BackendResponse_AdminUsageCounters extends BackendResponse<AdminUsageCounters> {}

// Récapitulatif des ressources d'un créateur (onglet « Ressources » de sa fiche). Lecture seule.
// Un bloc que le serveur n'a pas pu mesurer arrive à null : l'écran l'indique, il ne plante pas.
export interface AdminResourceQuota { used: number, max: number }

export interface AdminResources {
  quotas         : { devices: AdminResourceQuota, channels: AdminResourceQuota, disk: AdminResourceQuota, broadcast: AdminResourceQuota, recording: AdminResourceQuota },
  channels       : { total: number, active: number, deleted: number } | null,
  media          : { type: string, count: number, bytes: number }[] | null,
  recordings     : { count: number, bytes: number, seconds: number } | null,
  products       : number | null,
  regieConfigs   : number | null,
  socialNetworks : { total: number, active: number } | null,
  avatarModels?  : { count: number, bytes: number } | null,
}

// Détail d'une ligne du récapitulatif (les 60 plus récents), demandé au dépliage de la ligne.
export interface AdminResourceItem {
  id        : number,
  title     : string,
  subtitle  : string,
  date      : string | null,
  bytes     : number | null,
  badge     : string | null,
  publicRef : string | null,
  image     : 'thumbnail' | 'logo' | null,
  public?   : boolean,   // chaînes seulement : visible dans le portail public
  downloadUrl? : string | null,   // enregistrements seulement : null tant que le fichier est sur zircon
  // documents : fichier et accès ; configurations de régie : mire de la chaîne (2026-10-24)
  fileName?         : string | null,
  fileType?         : string | null,
  isPublic?         : boolean,
  channelPublicRef? : string | null,
  // réseaux sociaux : `code` du réseau ; produits : voir ci-dessous (2026-10-24)
  // produits seulement (2026-10-24) : prix en centimes, du premier prix de la première variante
  active?   : boolean,
  kind?     : string | null,
  code?     : string | null,
  priceHt?  : number | null,
  priceTtc? : number | null,
}

export interface AdminResourceItems { kind: string, total: number, items: AdminResourceItem[] }

export const getAdminResourceItems = async ( id: number , kind: string , includeDeleted: boolean = false ): Promise<BackendResponse<AdminResourceItems>> => {

  const url = API_URLS.getAdminResourceItems.replace ( '{id}' , `${id}` ).replace ( '{kind}' , encodeURIComponent ( kind ) ) + ( includeDeleted ? '?deleted=1' : '' );

  try
   {
    const response = await axios.get ( url );

    return response.status === 200
           ? { code: 1 , comment: 'ok' , payload: response.data as AdminResourceItems }
           : handleError<AdminResourceItems> ( response.status , 'Non-200 response from API' );
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<AdminResourceItems> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<AdminResourceItems> ( -102 , 'Unknown error' );
   }
};

export const getAdminResources = async ( id: number ): Promise<BackendResponse<AdminResources>> => {

  const url = API_URLS.getAdminResources.replace ( '{id}' , `${id}` );

  try
   {
    const response = await axios.get ( url );

    if ( response.status === 200 )
          {
           return { code: 1 , comment: 'ok' , payload: response.data as AdminResources };
          }
     else {
           return handleError<AdminResources> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<AdminResources> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<AdminResources> ( -102 , 'Unknown error' );
   }
};

// Distinct d'updateAdmin : AdminUpdate ne touche délibérément jamais les compteurs
// d'usage (voir son commentaire "Plafonds seulement, jamais les compteurs d'usage"),
// c'est une action de rattrapage manuelle, pas une édition de profil ordinaire.
// `field` omis réinitialise les trois — mais le front n'appelle plus que sur un seul
// champ à la fois (un bouton par compteur, cf. AdminSheet).
export const resetAdminUsageCounters = async ( id: number , field?: AdminUsageCounterField ) : Promise<BackendResponse_AdminUsageCounters> => {

  const url = API_URLS.resetAdminUsageCounters.replace ( '{id}' , `${id}` );

  try
   {
    const response = await axios.post ( url , field !== undefined ? { field } : undefined );

    if ( response.status === 200 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : {
                                nbDevicesUsed               : response.data?.nbDevicesUsed               ?? 0,
                                durationElapsedBroadcasting  : response.data?.durationElapsedBroadcasting ?? 0,
                                durationElapsedRecording     : response.data?.durationElapsedRecording    ?? 0,
                                disconnectedDevices          : response.data?.disconnectedDevices         ?? null,
                              },
                  }
          }
     else {
           return handleError<AdminUsageCounters> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<AdminUsageCounters> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<AdminUsageCounters> ( -102 , 'Unknown error' );
   }
};



export const updateAdmin = async ( id      : number             ,
                                   profile : AdminProfilePayload & { firstname?: string , lastname?: string } ) : Promise<BackendResponse<Admin>> => {

  const url = API_URLS.updateAdmin.replace ( '{id}' , `${id}` );

  try
   {
    const response = await axios.post ( url , profile );

    if ( response.status === 200 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : { ...initializedAdmin() , ...response.data },
                  }
          }
     else {
           return handleError<Admin> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<Admin> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<Admin> ( -102 , 'Unknown error' );
   }
};

export const getAdminBannerUrl = ( admin: Admin ): string => {

  if ( !admin.bannerFile || admin.bannerFile === '' ) return '';

  // Même mécanique qu'un media de type Video : image publique servie par le
  // serveur média sous files/public/{publicRef}/images/banner.webp
  if ( admin.publicRef && admin.publicRef !== '' )
   {
    return `${WWW_URLS.MediaServer}${admin.publicRef}/images/banner.webp${cacheBustingSuffix(admin)}`;
   }

  // Fallback admins legacy (bandeau uploadé avant la colonne uuid) : endpoint authentifié
  return API_URLS.getAdminBannerFile.replace ( '{id}' , `${admin.id}` );
};

export const updateAdminBanner = async ( id                      : number       ,
                                         bannerFileToUpload      : File | null  ,
                                         bannerMarkedForDeleting : boolean      ) : Promise<BackendResponse<string>> => {

  const url = API_URLS.updateAdminBanner.replace ( '{id}' , `${id}` );

  const formData = new FormData();

  if ( bannerFileToUpload      !== null ) { formData.append ( 'bannerFileToUpload'      , bannerFileToUpload ); }
  if ( bannerMarkedForDeleting          ) { formData.append ( 'bannerMarkedForDeleting' , 'true'             ); }

  try
   {
    const response = await axios.post ( url , formData );

    if ( response.status === 200 )
          {
           return {
                    code    : 1,
                    comment : 'ok',
                    payload : response.data?.bannerFile ?? '',
                  }
          }
     else {
           return handleError<string> ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      return handleError<string> ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError<string> ( -102 , 'Unknown error' );
   }
};

// deleteAssociatedUser : omis tant que l'appelant n'a pas tranché — AdminDeleting répond
// alors 409/requiresUserDeletionConfirmation (code -111) si le compte a un User associé,
// à charge pour l'écran de reposer la question puis rappeler avec true (supprime aussi le
// User, son email est libéré) ou false (rétrogradation : le User est conservé tel quel).
export const deleteAdmin = async ( id                    : number ,
                                   adminId?               : number ,
                                   deleteAssociatedUser?   : boolean ): Promise<BackendResponse> => {

  const url = API_URLS.deleteAdmin.replace ( '{id}' , `${id}` )
            + ( deleteAssociatedUser !== undefined ? `?deleteAssociatedUser=${deleteAssociatedUser}` : '' );

  const userAgentInformations = getUserAgentInformations ();
  const appInformations       = getAppInformations ();

  const headers = {
    'Accept'                   : 'application/ld+json',
    'User-Agent-Informations'  : `${userAgentInformations}`,
    'App-Informations'         : `${appInformations}`,
    'X-Admin-Id'               : adminId ?? ''
  };

  try
   {
    const response = await axios.delete ( url , { headers } );

    if ( response.status === 204 )
          {
           return {
                    code    : 1,
                    comment : 'Le compte a été supprimé.',
                    payload : {} as any
                  };
          }
     else {
           return handleError ( response.status , 'Non-200 response from API' );
          }
   }
  catch ( error )
   {
    if ( axios.isAxiosError ( error ) )
     {
      if ( error.response?.status === 409 && error.response?.data?.requiresUserDeletionConfirmation === true )
       {
        return {
                 code    : USER_DELETION_CONFIRMATION_REQUIRED_CODE ,
                 comment : error.response?.data?.associatedUser?.email ?? '' ,
                 payload : error.response?.data?.associatedUser?.id ?? 0
               };
       }

      if ( error.response?.status === 409 && error.response?.data?.alreadyDisabled === true )
       {
        return {
                 code    : ALREADY_PSEUDO_DELETED_CODE ,
                 comment : error.response?.data?.message ?? 'Ce compte est désactivé mais non supprimable totalement.' ,
                 payload : {} as any
               };
       }

      if ( error.response?.status === 409 )
       {
        return {
                 code    : -103,
                 comment : 'Ce compte est lié à d\'autres ressources.',
                 payload : {} as any
               };
       }

      return handleError ( -101 , error.response?.data?.detail ?? error.message );
     }
    return handleError ( -102 , 'Unknown error' );
   }
};
